import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import BodySmall from "../typography/BodySmall";

interface Props {
  onClick: (e?: any) => void;
  title: string;
  color?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const Container = styled.button<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 14px;
  color: ${theme.colors.text};
  background-color: transparent;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border-bottom: ${(props) =>
    props.disabled ? "none" : `1px solid ${theme.colors.text}`};
  padding: 2px 0px;
  width: fit-content;

  &:hover {
    filter: opacity(0.6);
  }

  &:active {
    border-bottom: none;
    color: black;
  }
`;

const TextLinkButton: React.FC<Props> = ({
  onClick,
  title,
  color = theme.colors.text,
  icon,
  disabled,
}) => {
  return (
    <Container onClick={onClick} disabled={disabled}>
      <BodySmall color={color}>{title}</BodySmall>
      {icon && <VerticalSpacer spacing={0.25} />}
      {icon && icon}
    </Container>
  );
};

export default TextLinkButton;
